import CmsModelState from '../_util/cms-model';

class CMSPressState extends CmsModelState {
  get url() { return '/press'; }
  get singular() { return 'press'; }
  get plural() { return 'press'; }
}

export default CMSPressState;



// WEBPACK FOOTER //
// ./spa/state/cms/cms-press.jsx